export const CONSTRUCTOR_BLOCKS_TYPES = {
  BORDERED_IMAGE_LIST: 'bordered_image_list',
  BORDERLESS_IMAGE_LIST: 'borderless_image_list',
  BRANDS: 'brands',
  DOUBLE_IMAGE: 'double_image',
  GALLERY: 'gallery',
  GALLERY_BANNERS: 'gallery_banners',
  GALLERY_UNIFIED: 'gallery_unified',
  IMAGE: 'image',
  OFFER_GALLERY: 'offer_gallery',
  PARAMS_TABLE: 'params_table',
  PRODUCT_GALLERY: 'product_gallery',
  SCRIPT: 'js_script',
  TEXT: 'text',
  TILES: 'tiles',
  VIDEO: 'video',
  VIDEO_FRAME: 'video_frame',
};
